import React from "react";
import { useWindowDimensions } from "resources/BrowserManager";

import TopBar from "components/Layout/TopBar";
import SideBar from "components/Layout/SideBar";

import { Layout } from "antd";
import "./style.scss";

const { Content } = Layout;

const styleWrapperClass = "base";
const siderWidth = 256;

function Base(props) {
  const { width, isSmallView } = useWindowDimensions();
  const hideSider = width <= 1100;

  return (
    <div className={styleWrapperClass}>
      <Layout>
        {!!!hideSider && <SideBar siderWidth={siderWidth} />}
        <Layout style={!!!hideSider && { marginLeft: siderWidth }}>
          <TopBar hideSider={hideSider} siderWidth={siderWidth} />
          <Content
            style={{
              padding: isSmallView ? "5px 20px" : "20px 20px",
            }}
          >
            {props.children}
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default Base;
